import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";

const faqs = [
  {
    question: "What types of textile machinery components do you manufacture?",
    answer:
      "We manufacture a comprehensive range of textile machinery components including ring travellers, spindle components, ceramic machine parts, and industrial spinning equipment. Our products are available in various sizes and configurations to meet different machinery specifications."
  },
  {
    question: "Do you offer custom manufacturing services?",
    answer:
      "Yes, we provide custom manufacturing services tailored to specific requirements. Our engineering team can work with you to design and produce components that meet your exact specifications, ensuring optimal performance for your machinery."
  },
  {
    question: "What is the minimum order quantity for your products?",
    answer:
      "Minimum order quantities vary depending on the product type and specifications. For standard components, we typically maintain lower MOQs, while custom-manufactured parts may require larger minimum orders. Please contact our sales team for specific information regarding your needs."
  },
  {
    question: "Do you provide installation and maintenance services?",
    answer:
      "Yes, we offer professional installation and maintenance services for all our products. Our team of experienced technicians can assist with installation, commissioning, and regular maintenance to ensure optimal performance and longevity of your machinery components."
  },
  {
    question: "How long does shipping and delivery typically take?",
    answer:
      "Shipping times vary depending on your location and the specific products ordered. Standard components are typically shipped within 1-2 weeks, while custom orders may require 3-4 weeks for manufacturing before shipping. International shipments usually take 1-3 weeks for delivery after dispatch."
  },
  {
    question: "Do you offer technical support for your products?",
    answer:
      "Yes, we provide comprehensive technical support for all our products. Our team of engineers and technical specialists is available to assist with any issues or questions you may have regarding installation, operation, maintenance, or troubleshooting."
  }
];

export default function Faq() {
  return (
    <div className="container py-16 px-4 md:px-6">
      <div>
        <div className="max-w-3xl">
          <motion.h1 
            className="text-4xl font-bold tracking-tight"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            Frequently Asked Questions
          </motion.h1>
          <motion.p 
            className="mt-4 text-lg text-muted-foreground leading-relaxed"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            Find answers to common questions about our products, services, and business operations. 
            If you can't find what you're looking for, please contact our support team.
          </motion.p>
        </div>

        <motion.div 
          className="mt-16 max-w-4xl"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={`faq-item-${index}`} 
                value={`item-${index}`} 
                className="border border-slate-200 rounded-lg mb-4 px-6 shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <AccordionTrigger className="text-left font-medium py-6 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>

        <motion.div
          className="mt-20 max-w-3xl rounded-lg p-8"
          style={{ backgroundColor: '#f0ede8' }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.8 }}
        >
          <h2 className="text-2xl font-semibold mb-4">Still have questions?</h2>
          <p className="text-muted-foreground leading-relaxed mb-6">
            If you couldn't find the answer to your question, please feel free to contact our customer 
            support team. We're here to help you with any inquiries regarding our products and services.
          </p>
          <motion.div
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.2 }}
          >
            <a 
              href="/contact" 
              className="inline-flex items-center rounded-md bg-primary px-6 py-3 text-sm font-medium text-primary-foreground hover:bg-primary/90 shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              Contact Support
            </a>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}